<template>
  <div class="productItem" @click.prevent="handleClick">
    <a :href="`product/${slug}`">
      <div class="pic">
        <span v-if="showBadge" class="class-tag badge badge-orange" v-html="badgeText"></span>
        <img v-if="picUrl" :src="picUrl" title="" alt="" onerror="javascript:this.src='img/pic/no_image_icon.png'"/>
      </div>
    </a>
    <div class="favoriteBox">
      <button
        id="colletBtn"
        :class="favoriteButtonClass"
        @click="changeFavorite"
      >
        <img :src="computedLoveIcon" title="加入喜愛清單" />
      </button>
      <div class="ratingNumber">
        <span class="star-icon"><img :src="computedStarIcon" alt="star rating" /></span>
        <span>{{ formatRating }} </span>
        <span>({{ ratingCount }})</span>
      </div>
    </div>
    <a :href="`product/${slug}`">
      <h3 v-if="pageType == 'list'"><div class="name">{{ name }}</div></h3>
      <h4 v-else><div class="name">{{ name }}</div></h4>
      <input type="hidden" class="type_id_specId_key" :data-type_id_specId_key="typeIdSpecIdKey" name="type_id_specId_key[]" :value="typeIdSpecIdKey">
      <div class="originalPrice" v-show="priceLowCheck()">NT$ {{ originalPrice }}元</div>
      <div v-if="minPrice == 0" class="price">免費</div>
      <div v-else class="price">NT$ {{ minPrice }}元</div>
    </a>
  </div>
</template>

<script>
import Datalayer from 'Controllers/Web/Datalayer';

export default {
  props: {
    productId: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    pageName: {
      type: String,
      default: '',
    },
    pagePosition: {
      type: String,
      default: '',
    },
    slug: {
      type: String,
      default: '',
    },
    picUrl: {
      type: String,
      default: '',
    },
    originalPrice: {
      type: Number,
      default: 0,
    },
    minPrice: {
      type: Number,
      default: 0,
    },
    favoriteAdded: {
      type: Boolean,
      defalut: false,
    },
    preorderActive: {
      type: Boolean,
      defalut: false,
    },
    preorderFromDate: {
      type: String,
      default: '',
    },
    preorderToDate: {
      type: String,
      default: '',
    },
    rating: {
      type: Number,
      default: 0,
    },
    ratingCount: {
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: '',
    },
    typeIdSpecIdKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      favoriteAddedData: false,
      formatRating: this.rating,
      badgeText: '',
      showBadge: false,
      computedLoveIcon: 'img/pic/love.svg',
      computedStarIcon: 'img/pic/star.png',
      link: '',
    };
  },
  computed: {
    favoriteButtonClass() {
      return {
        favoriteBtn: true,
        'class-collet': true,
        added: this.favoriteAddedData,
      };
    },
  },
  created() {
    this.favoriteAddedData = this.favoriteAdded;
    this.showBadge = ['start'].includes(this.getPreOrderStatus());
    this.link = `product/${this.slug}`;
  },
  mounted() {
    if (this.formatRating !== 0) {
      this.formatRating = this.formatRating.toFixed(1);
    }
  },
  methods: {
    async handleClick(event) {
      if(this.pagePosition !== '' || this.pageName !== ''){
        event.preventDefault();
        const position = `${this.pageName}_product_${this.pagePosition}`;
        await Datalayer.storeDatalayerEvent(this.name, position);
      }
      window.location.href = this.link;
    },
    priceLowCheck(){
      return this.minPrice < this.originalPrice;
    },
    getPreOrderStatus() {
      if (this.preorderActive) {
        const now = new Date();
        const fromDate = new Date(this.preorderFromDate);
        const toDate = new Date(this.preorderToDate);
        if (fromDate < now && toDate >= now) {
          this.badgeText = '預購中';
          return 'start';
        } else if (fromDate > now) {
          this.badgeText = '';
          return 'notStart';
        } else {
          this.badgeText = '預購結束';
          return 'end';
        }
      } else {
        return 'notPreOrder';
      }
    },
    async changeFavorite() {
      // 改為相反的狀態
      this.favoriteAddedData = !this.favoriteAddedData;

      let response;
      try {
        response = await axios.post(
          `product/favorite/${this.productId}`,
        );
      } catch (error) {
        console.warn(error);
      }

      const { data } = response;

      if (data.status === 'not login') {
        window.location.href = 'user/login';

        Message.show('請先登入會員');

        return false;
      }

      if (data.favoriteAdded) {
        Message.show('已經加入喜愛產品');
      } else {
        Message.show('已經從喜愛產品中移除');
      }

      this.favoriteAddedData = data.favoriteAdded;
    },
  },
};
</script>
<style lang="scss" scoped>
$maincolor: #72ca4a;
.originalPrice {
  position: relative;
  display: inline-block;
  color: #999;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #999;
  }
}
.productItem {
    position: relative;
    display: block;
    padding: 2rem 2rem;
    background: white;
    transition: 0.3s;
    @media (max-width: 769px) {
        padding: 2rem;
    }
    @media (max-width: 480px) {
        padding: 0;
    }
    &:hover {
        transition: 0.3s;
        border-bottom: solid 10px $maincolor;
        border-right: solid 10px $maincolor;
    }
    .pic {
        background-color: #eee;
        img {
            width: 100%;
        }
    }
    .favoriteBox {
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;
        .favoriteBtn {
            width: 30px;
            cursor: pointer;
            background: none;
            border: none;
            &:hover,
            &.added {
                img {
                    transition: 0.3s;
                    background: url(../img/pic/love_green.svg) no-repeat;
                    background-size: contain;
                }
            }
        }
        .ratingNumber {
            display: flex;
            align-items: center;
            color: #333;
            img {
                width: 18px;
                margin-right: 6px;
            }
            span {
                color: #999;
                margin-left: 3px;
            }
        }
    }
    .name {
        margin-top: 1rem;
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }
    .price {
        display: block;
        color: $maincolor;
        font-size: 16px;
        font-weight: 500;
        margin-top: 0.5rem;
    }
}
</style>
